import { WORLD_WIDTH } from "../game/constants";

export class Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  maxLife: number;
  color: string;
  size: number;
  rot = Math.random() * Math.PI;
  confetti: boolean;

  constructor(x: number, y: number, color: string, confetti = false) {
    this.x = x;
    this.y = y;
    const ang = Math.random() * Math.PI * 2;
    const spd = confetti ? 80 + Math.random() * 220 : 60 + Math.random() * 180;
    this.vx = Math.cos(ang) * spd;
    this.vy = Math.sin(ang) * spd - 80;
    this.maxLife = confetti ? 0.7 + Math.random() * 0.4 : 0.35 + Math.random() * 0.25;
    this.life = this.maxLife;
    this.color = color;
    this.size = confetti ? 4 + Math.random() * 5 : 3 + Math.random() * 4;
    this.confetti = confetti;
  }

  update(dt: number): void {
    this.life -= dt;
    this.x += this.vx * dt;
    this.y += this.vy * dt;
    this.vy += 420 * dt;
    this.rot += dt * 8;
  }

  get alive(): boolean {
    return this.life > 0;
  }

  draw(ctx: CanvasRenderingContext2D): void {
    const a = Math.max(0, this.life / this.maxLife);
    ctx.save();
    ctx.globalAlpha = a;
    ctx.translate(this.x, this.y);
    ctx.rotate(this.rot);
    ctx.fillStyle = this.color;
    if (this.confetti) ctx.fillRect(-this.size * 0.5, -this.size * 0.2, this.size, this.size * 0.45);
    else {
      ctx.beginPath();
      ctx.arc(0, 0, this.size, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.restore();
  }
}

export function burst(x: number, y: number, color: string, gold: boolean, reduceMotion: boolean): Particle[] {
  const n = reduceMotion ? 6 : gold ? 28 : 14;
  const c = reduceMotion ? 4 : gold ? 18 : 10;
  const out: Particle[] = [];
  for (let i = 0; i < n; i += 1) out.push(new Particle(x, y, color, false));
  const extras = gold ? ["#fff3b0", "#fff", "#ff9f1c"] : [color, "#fff"];
  for (let i = 0; i < c; i += 1) {
    out.push(new Particle(x, y, extras[i % extras.length] ?? color, true));
  }
  return out;
}

export function confettiRain(record: boolean, reduceMotion: boolean): Particle[] {
  const n = reduceMotion ? (record ? 14 : 6) : record ? 88 : 36;
  const colors = ["#ff6b8a", "#ffd24a", "#3db8ff", "#7ad36a", "#fff", "#ff8a5b"];
  const out: Particle[] = [];
  for (let i = 0; i < n; i += 1) {
    const p = new Particle((i * 97) % WORLD_WIDTH, -10 - (i % 7) * 8, colors[i % colors.length] ?? "#fff", true);
    p.vy = 40 + (i % 5) * 30;
    p.vx = (i % 9) * 18 - 70;
    if (reduceMotion) {
      p.vy *= 0.15;
      p.vx *= 0.1;
    }
    out.push(p);
  }
  return out;
}
